module.exports = __webpack_public_path__ + "img/loading.7ab2fb7a.gif";